"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    copyrightMessage: '©2019 TargetX All Rights Reserved',
    logoDescription: 'TargetX',
    supportMessage: 'Having Trouble?',
    supportLinkText: 'Contact Support',
    title: 'Sign In'
};
